const MODULE = "Cruise";

const ACTIONS = {
  CONTENT_DUPLICATED: "Sailing Content Duplicated",
  STATUS_ACTIVATED: "Sailing Status Activated"
};

export const SAILING_PAGE_LOG_TYPES = {
  MODULE,
  ACTIONS
};